import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { requestDeviceUpdate } from 'console/redux/devices/items/actions';
import { createSelector } from '@reduxjs/toolkit';
import { LegacyDevice } from 'console/device/device';
import { createSubsetSelector } from 'webui/utils/selectors';
import { Capability } from 'console/device/device-capability';
import { useCallback, useMemo } from 'react';
import { selectSelectedDevice } from 'entities/device/lib';
const selectDevice = createSelector((state) => selectSelectedDevice(state), createSubsetSelector(['capabilities', 'id']));
export function useLegacySaver() {
    const device = useAppSelector(selectDevice);
    const _requestDeviceUpdate = useAction(requestDeviceUpdate);
    const has_z3k_settings = useMemo(() => device != null
        ? LegacyDevice.has_capability(device?.capabilities, Capability.has_z3k_settings)
        : false, [device?.capabilities]);
    const has_wifi = useMemo(() => device != null
        ? LegacyDevice.has_any_capability(device?.capabilities, [
            Capability.has_wifi,
            Capability.has_wifi_v2,
        ])
        : false, [device?.capabilities]);
    const is_old_device = useMemo(() => !has_z3k_settings && has_wifi, [has_wifi, has_z3k_settings]);
    const onSave = useCallback((name, password) => {
        if (is_old_device && device != null) {
            const wifi_credentials = {
                '0': {
                    ssid: name,
                    password: password,
                },
            };
            _requestDeviceUpdate(device.id, { wifi_credentials }, {
                ignore_server_response: true,
                obey_only_last_response: true,
            });
        }
    }, [is_old_device, device?.id, _requestDeviceUpdate]);
    return onSave;
}
